module.exports = __webpack_public_path__ + "img/ico-projects.63e66e1.svg";